export default __webpack_public_path__ + "static/media/cover-clerk@3x.58ca7356.png";